import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

// 実力テスト成績詳細取得（力だめし/定着度）

export namespace ApiTaRe190 {
  // API Name
  export const name: string = 'ApiTaRe190'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/learningAssessmentScore'

    export interface Request {
      query: {
        fiscalYear: number
        month: number
        times?: number
        grade: number
        courseId: string
      }
    }

    export interface Response {
      fixabilityTestResults: {
        memNum: string
        title: string
        gradeDataResults: {
          subjectCode: string
          answerId: string
          score: string
          average: string
          deviationValue: string
        }[]
        difficultyResults: {
          subjectCode: string
          resultsByQuestion: {
            questionNo: number
            basicsScoreRate: string
            practicalScoreRate: string
          }[]
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        fixabilityTestResults: {
          memNum: '',
          title: '',
          gradeDataResults: [
            {
              subjectCode: '',
              answerId: '',
              score: '',
              average: '',
              deviationValue: '',
            },
          ],
          difficultyResults: [
            {
              subjectCode: '',
              resultsByQuestion: [
                {
                  questionNo: 0,
                  basicsScoreRate: '',
                  practicalScoreRate: '',
                },
              ],
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
